import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Toast from '../components/Toast';
import Logo from '../components/Logo';
import GoogleSignInButton from '../components/GoogleSignInButton';
import api from '../services/api';

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [toast, setToast] = useState<{ message: string; type: 'success' | 'error' | 'info' | 'warning' } | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setToast(null);

    if (password.length < 8) {
      setToast({ message: 'Passwort muss mindestens 8 Zeichen lang sein', type: 'error' });
      return;
    }

    setLoading(true);

    try {
      await api.post('/auth/register', { email, password, name });
      setToast({ message: 'Registrierung erfolgreich! Code wurde per Email versendet.', type: 'success' });
      
      // Weiterleitung zur Email-Verifizierung
      setTimeout(() => {
        navigate('/verify-email', { state: { email } });
      }, 1000);
    } catch (err: any) {
      setToast({ message: err.response?.data?.message || 'Registrierung fehlgeschlagen', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem', backgroundColor: 'var(--bg-secondary)' }}>
      <div className="card" style={{ width: '100%', maxWidth: '400px' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ display: 'inline-block' }}>
            <Logo variant="dark" />
          </div>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginTop: '1rem' }}>Konto erstellen</h2>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <label htmlFor="name" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
              Name
            </label>
            <input
              id="name"
              type="text"
              className="input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              autoComplete="name"
            />
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <label htmlFor="email" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
              E-Mail
            </label>
            <input
              id="email"
              type="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label htmlFor="password" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
              Passwort
            </label>
            <input
              id="password"
              type="password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="new-password"
              minLength={8}
            />
            <p style={{ fontSize: '0.875rem', color: 'var(--gray-500)', marginTop: '0.25rem' }}>
              Mindestens 8 Zeichen
            </p>
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', marginBottom: '1rem' }}
            disabled={loading}
          >
            {loading ? 'Wird erstellt...' : 'Registrieren'}
          </button>

          <p style={{ textAlign: 'center', color: 'var(--gray-600)' }}>
            Bereits ein Konto?{' '}
            <Link to="/login" style={{ color: 'var(--primary)', textDecoration: 'none', fontWeight: '500' }}>
              Anmelden
            </Link>
          </p>
        </form>

        {/* Google Sign-In */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', margin: '1.25rem 0' }}>
          <div style={{ flex: 1, height: '1px', backgroundColor: 'var(--gray-200)' }} />
          <span style={{ color: 'var(--gray-400)', fontSize: '0.875rem', whiteSpace: 'nowrap' }}>oder</span>
          <div style={{ flex: 1, height: '1px', backgroundColor: 'var(--gray-200)' }} />
        </div>

        <GoogleSignInButton
          onSuccess={() => navigate('/')}
          onError={(msg) => setToast({ message: msg, type: 'error' })}
        />
      </div>

      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
}
